import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql, Link } from 'gatsby'

const Categories = () => {
  const data = useStaticQuery(graphql`
    query Categories {
      allContentfulCategory {
        edges {
          node {
            name
            slug
          }
        }
      }
      allContentfulPost {
        distinct(field: categories___name)
      }
    }
  `)
  const { edges: categories } = data.allContentfulCategory
  const { distinct } = data.allContentfulPost
  const categoriesByPosts = categories.filter(({ node }) => {
    const category = distinct.find(name => name === node.name)
    if (category) {
      return node
    }

    return false
  })
  return (
    <div className='nile-widget layout-1 widget_categories'>
      <div className='title text-main-color'>Categories</div>
      <ul>
        {
          categoriesByPosts.map(({ node }, index) => {
            return (<li key={index}><Link to={`/category/${node.slug}`}>{node.name}</Link></li>)
          })
        }
      </ul>
    </div>
  )
}

Categories.propTypes = {
  type: PropTypes.string
}

Categories.defaultProps = {
  type: ''
}

export default Categories
